var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isGoogleApiLoaded)?_c('div',_vm._l((_vm.order.places),function(orderPlace,index){return _c('OrderPlaceField',{key:'opf-' + index,attrs:{"disabled":_vm.isFulfilledOrder,"order-place":orderPlace,"index":index,"is-last":_vm.order.places.length - 1 === index,"client":_vm.order.client}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }